import axios from "axios";
import { API_PROD_URL } from "src/utils/axios";

const verrifyPaymentEndpoint = "/stripe/payment-status";
const MAX_RETRIES = 3;

export async function verifyPaymentStatus(user_id: string, thread_id: string) {
    for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
        try {
            const response = await axios.get(
                `${API_PROD_URL}${verrifyPaymentEndpoint}`,
                {
                params: {
                    user_id,
                    thread_id,
                },
                headers: {
                    "Content-Type": "application/json",
                },
                }
            );

            const data = response.data;


            if (Array.isArray(data) && data[7] === "succeeded") {
                return "success";
            } 
     
            else if (Array.isArray(data) && typeof data[7] === "string") {
                console.warn(
                    `Attempt ${attempt}: Payment not succeeded yet. Status: ${data[7]}`
                );
            } 
         
            else {
                console.warn(`Attempt ${attempt}: Unexpected response`, data);
            }

          
            if (attempt < MAX_RETRIES) {
                await new Promise(res => setTimeout(res, 1000)); 
            }
        } catch (error) {
            console.error(`Attempt ${attempt} failed:`, error);
          
            if (attempt === MAX_RETRIES) throw error;
        }
    }

 
    throw new Error("Payment status did not succeed after 3 attempts");
}
